<template>
  <select v-model="selectedLang" class="language-dropdown" :disabled="disabled"
    @change="$emit('change', $event.target.value)">
    <option value="" disabled selected>{{ $t('chooseLanguageTranslate') }}</option>
    <option v-for="lang in languages" :key="lang.code" :value="lang.code">
      {{ $t(lang.name) }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'LanguageDropdown',
  props: {
    value: String,
    languages: {
      type: Array,
      required: true
    },
    disabled: Boolean
  },
  computed: {
    selectedLang: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
};
</script>

<style scoped>
.language-dropdown {
  width: 100%;
  font-family: 'Montserrat';
  padding: 16px 12px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 6px;
  background-color: var(--container-color);
  color: var(--text-color);
  margin-bottom: 12px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

body[data-theme="dark"] .language-dropdown {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
}

body[data-theme="light"] .language-dropdown {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
}

.language-dropdown:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.language-dropdown:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--highlight-color);
}
</style>